// Plain-language, fully bilingual presentation helpers for the Financials
// "Story of the Money" tab. Pure presentation — never alters any number.

import ACCOUNT_NAMES from "./accountNames.json";

// Everyday bilingual names for expense groups, keyed by the backend group key
// returned from /financials/expenses (financials_query.GROUP_META keys).
export const FIN_GROUP_LABELS = {
    operating: { ar: "التشغيل", en: "Food & Operating" },
    salaries: { ar: "الرواتب", en: "Salaries" },
    app_commission: { ar: "عمولة التطبيقات", en: "Delivery-app commission" },
    rent: { ar: "الإيجارات", en: "Rent" },
    admin: { ar: "إدارية", en: "Admin" },
    labor_gov: { ar: "تأمينات ورسوم العمالة", en: "Staff insurance & fees" },
    depreciation: { ar: "الإهلاك", en: "Depreciation" },
    other: { ar: "أخرى", en: "Other" },
};

// Distinct, brand-aligned chart colors per group (no purple/pink).
export const FIN_GROUP_COLORS = {
    operating: "#D1802F", // brand orange
    salaries: "#2563EB", // calm blue
    app_commission: "#0EA5A4", // teal — key drain highlight
    rent: "#8F340C", // brand brown
    admin: "#64748B", // slate
    labor_gov: "#CA8A04", // gold
    depreciation: "#78716C", // warm gray
    other: "#A8A29E", // light warm gray
};

// Semantic colors (Financials-scoped — match --fin-profit / --fin-loss / sales).
export const FIN_PROFIT = "#16A34A";
export const FIN_LOSS = "#DC2626";
export const FIN_SALES = "#D1802F";

// Canonical order used by the money-flow waterfall (Sales → costs → kept).
export const FIN_GROUP_ORDER = [
    "operating",
    "salaries",
    "app_commission",
    "rent",
    "admin",
    "labor_gov",
    "depreciation",
    "other",
];

// Months that fall within Ramadan (no Ramadan flag exists in the data, so this
// is a fixed, user-confirmed list). Ramadan 1446 ≈ Mar 2025; 1447 ≈ mid-Feb→mid-Mar 2026.
export const RAMADAN_MONTHS = new Set(["2025-03", "2026-02", "2026-03"]);

export function groupLabel(key, lang) {
    const m = FIN_GROUP_LABELS[key] || FIN_GROUP_LABELS.other;
    return lang === "ar" ? m.ar : m.en;
}

export function groupColor(key) {
    return FIN_GROUP_COLORS[key] || FIN_GROUP_COLORS.other;
}

// Currency label that matches the active language (kept separate from Sales' ر.س).
export function finCurrency(lang) {
    return lang === "ar" ? "ريال" : "SAR";
}

export function isRamadan(ym) {
    return RAMADAN_MONTHS.has(ym);
}

// Bilingual P&L account-line name, matched by account_id. Falls back to the
// stored Arabic name (from the API) when an id is missing from the dictionary.
export function accountName(accountId, fallback, lang) {
    const entry = ACCOUNT_NAMES[String(accountId)];
    if (entry) {
        const name = lang === "ar" ? entry.ar : entry.en;
        if (name) return name;
    }
    return fallback || "";
}
